<template>
  <span class="locked-item-component" @click="checkPrivilidge">
    <slot name="title" />
    <i 
      v-show="locked && !isLogin"
      class="lock-icon"
    />
  </span>
</template>

<script>
import {mapState, mapMutations} from 'vuex'

export default {
  props: {
    locked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  methods: {
    ...mapMutations({
      login: 'LOGIN_SHOW'
    }),
    checkPrivilidge () {
      if (this.locked && !this.isLogin) {
        this.login()
      } else {
        this.$emit('toDetail')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .lock-icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-top: 5px;
    background: url("../../assets/img/lock.png") no-repeat;
    background-size: 100% 100%;
  }
</style>


// WEBPACK FOOTER //
// src/modules/common/lockedItem.vue